import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
import { jsxs, jsx } from 'react/jsx-runtime';
import { Row, theme as theme$1, Text, Column, Grid, Spacing } from '@dls/web';
import styled, { css } from 'styled-components';
import { Close } from '@dls/assets/icons';
import Logo from './Logo.js';
import Logout from './Logout.js';
import Notification from './Notification.js';
import Profile from './Profile.js';
import UserEntity from './UserEntity.js';
import theme from '../../../../theme/index.js';
import { remCalc } from '../../../../helpers/styles.js';
import '@geit/ui-components';
import '../../../../../../authentication/context/AuthenticationProvider.js';
import 'react';
import useAppModule from '../../../../../../authentication/hooks/useAppModule.js';
import 'qs';
import 'uuid';
import '../../../../../../authentication/navigate.js';
import Anchor from '../../../Anchor/index.js';
const SCHamburgerMenu = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: ", ";\n  border-top: 4px solid ", ";\n  opacity: 0;\n  overflow-y: auto;\n  visibility: hidden;\n  z-index: 99999;\n\n  transition: all 400ms ease-out;\n  transform: translate(-200px, 0);\n\n  ", ";\n\n  ", ";\n"])), props => props.theme === "dark" ? theme.colours.darkslate : theme.colours.white, theme.colours.singtelred, props => props.isHamburgerMenuOpen && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      transform: translate(0, 0);\n      opacity: 1;\n      visibility: visible;\n    "]))), theme.media.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  transform: translate(-100vw, 0);\n  "]))));
const SCHamburgerHeader = styled(Row)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 64px;\n"])));
const SCMenuCloseIcon = styled(Close)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  float: right;\n\n  & path {\n    fill: ", ";\n  }\n"])), props => props.theme === "dark" ? theme$1.main.colours.white : theme$1.main.colours.black);
const SCFirstLevelMenuTitle = styled(Text)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), props => props.theme === "dark" ? theme$1.main.colours.white : theme$1.main.colours.black);
const SCColumnPrimaryMenuItem = styled(Column)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  padding: 0 ", ";\n"])), remCalc(8));
const SCColumnSubMenuItem = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding-left: ", ";\n  padding-bottom: ", ";\n"])), remCalc(8), remCalc(8));
const SCAnchorBlack = styled(Anchor)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  display: block;\n  text-decoration: none;\n  outline: 0;\n\n  &:not([disabled]) {\n    &.active {\n      font-family: ", ";\n    }\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), props => props.theme === "dark" ? theme$1.main.colours.white : theme$1.main.colours.black, theme.fonts.sizes.regular, theme.fonts.families.LatoHeavy, props => props.theme === "dark" ? theme$1.main.colours.white : theme.colours.singtelred);
const Divider = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  margin: ", " ", ";\n  border-bottom: 1px solid ", ";\n"])), remCalc(16), remCalc(-16), theme.colours.grey_e2);
const StyledIconColumn = styled(Column)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  height: ", ";\n"])), remCalc(16));
const MobileMenu = _ref => {
  let {
    baseUrl,
    isHamburgerMenuOpen,
    logoLink,
    logoAlt,
    logoSrc,
    onClose,
    theme: theme2,
    menuItems = [],
    isAnonymous,
    additionalControl,
    onClickMenu
  } = _ref;
  var _a;
  const {
    appModule
  } = useAppModule();
  const onMenuItemClick = menuItem => {
    onClickMenu == null ? void 0 : onClickMenu({
      menuItem
    });
    onClose == null ? void 0 : onClose();
  };
  const onCloseMenu = () => {
    onClose == null ? void 0 : onClose();
  };
  if (typeof document !== "undefined" && isHamburgerMenuOpen) {
    document.body.style.overflow = "hidden";
  }
  if (typeof document !== "undefined" && !isHamburgerMenuOpen) {
    document.body.removeAttribute("style");
  }
  return /* @__PURE__ */jsxs(SCHamburgerMenu, {
    isHamburgerMenuOpen,
    theme: theme2,
    children: [/* @__PURE__ */jsxs(Grid, {
      children: [/* @__PURE__ */jsxs(SCHamburgerHeader, {
        middle: "xs",
        children: [/* @__PURE__ */jsx(StyledIconColumn, {}), /* @__PURE__ */jsx(Column, {
          children: /* @__PURE__ */jsx(Logo, {
            baseUrl,
            link: logoLink,
            alt: logoAlt,
            src: logoSrc,
            onClick: onClose
          })
        }), /* @__PURE__ */jsx(StyledIconColumn, {
          children: /* @__PURE__ */jsx(SCMenuCloseIcon, {
            width: 24,
            onClick: onClose,
            theme: theme2
          })
        })]
      }), !!appModule && /* @__PURE__ */jsxs(Row, {
        middle: "xs",
        children: [/* @__PURE__ */jsxs(SCColumnPrimaryMenuItem, {
          xs: 12,
          children: [/* @__PURE__ */jsx(Spacing, {
            top: 3,
            children: /* @__PURE__ */jsx(SCFirstLevelMenuTitle, {
              type: "boldBody",
              theme: theme2,
              children: appModule.moduleName
            })
          }), /* @__PURE__ */jsx(Divider, {})]
        }), (_a = appModule.features) == null ? void 0 : _a.map((menuItem, subKey) => {
          return /* @__PURE__ */jsxs(Column, {
            xs: 12,
            children: [/* @__PURE__ */jsx(SCColumnSubMenuItem, {
              children: /* @__PURE__ */jsx(SCAnchorBlack, {
                href: menuItem.url,
                onClick: () => onMenuItemClick(menuItem),
                theme: theme2,
                children: menuItem.featureName
              })
            }), /* @__PURE__ */jsx(Divider, {})]
          }, subKey);
        })]
      })]
    }), !isAnonymous && /* @__PURE__ */jsx(SCBottomBarGrid, {
      children: /* @__PURE__ */jsx(Row, {
        children: /* @__PURE__ */jsxs(SCColumn, {
          xs: 12,
          children: [/* @__PURE__ */jsx(SCLeftHandColumn, {
            children: /* @__PURE__ */jsx(UserEntity, {
              onApplyChange: onCloseMenu,
              isMobile: true
            })
          }), /* @__PURE__ */jsxs(SCRightHandColumn, {
            children: [/* @__PURE__ */jsx(Profile, {
              theme: theme2,
              onClick: onCloseMenu,
              url: "/account/profile"
            }), /* @__PURE__ */jsx(Notification, {
              theme: theme2,
              onClick: onCloseMenu
            }), additionalControl, /* @__PURE__ */jsx(Logout, {
              theme: theme2,
              onClick: onCloseMenu
            })]
          })]
        })
      })
    })]
  });
};
const SCBottomBarGrid = styled(Grid)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n"])));
const SCColumn = styled(Column)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n"])));
const SCLeftHandColumn = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n"])));
const SCRightHandColumn = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
export { SCHamburgerMenu, MobileMenu as default };